"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasWriteAccessForAccountById = exports.isTransferAccountAvailable = exports.firstBankAccount = exports.txnListHasAttachment = exports.newRegFields = void 0;
const immutable_1 = require("immutable");
const accounts_1 = require("companion-app-components/flux/accounts");
const transactions_1 = require("companion-app-components/flux/transactions");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const accountGroupUtils_1 = require("companion-app-components/flux/account-groups/accountGroupUtils");
const store_1 = __importDefault(require("store"));
const utils_1 = require("utils/utils");
const transactionsConfig = __importStar(require("./transactionsConfig"));
const newRegFields = (doubleAmounts) => {
    const objTxnConfig = transactionsConfig.fieldData;
    const editables = Object.keys((0, utils_1.filterByKeys)(objTxnConfig, (config) => config.editable));
    if (doubleAmounts) {
        editables.splice(editables.indexOf('amount'), 1);
    }
    else {
        editables.splice(editables.indexOf('income'), 1);
        editables.splice(editables.indexOf('expense'), 1);
    }
    return (0, immutable_1.List)(editables);
};
exports.newRegFields = newRegFields;
const txnListHasAttachment = (txnMap, txnBeingEdited) => {
    let foundAttachment = false;
    if (txnBeingEdited && txnBeingEdited.attachments && txnBeingEdited.attachments.length > 0) {
        return true;
    }
    if (txnMap) {
        txnMap.keySeq().forEach((key) => {
            const txnMapKey = txnMap.get(key);
            if (!foundAttachment && txnMapKey) {
                foundAttachment = txnMapKey.find((txn) => (Boolean(txn.attachments && txn.attachments.length > 0)));
            }
        });
    }
    return foundAttachment;
};
exports.txnListHasAttachment = txnListHasAttachment;
const firstBankAccount = (accountIds) => {
    const ret = accountIds.filter((id) => !(accounts_1.accountsUtils.isLoanAccount(accounts_1.accountsSelectors.getAccountById(store_1.default.getState(), id))
        || accounts_1.accountsUtils.isInvestmentAccount(accounts_1.accountsSelectors.getAccountById(store_1.default.getState(), id))));
    const sorted = ret.sort((objAccount1, objAccount2) => {
        // @ts-expect-error - FIXME: Expected 2 arguments, but got 1.ts(2554)
        if (accounts_1.accountsUtils.isBankAccountFromId(objAccount1)) {
            // @ts-expect-error - FIXME: Expected 2 arguments, but got 1.ts(2554)
            return accounts_1.accountsUtils.isBankAccountFromId(objAccount2) ? 0 : -1;
        }
        // @ts-expect-error - FIXME: Expected 2 arguments, but got 1.ts(2554)
        return accounts_1.accountsUtils.isBankAccountFromId(objAccount2) ? 1 : 0;
    });
    return sorted.first();
};
exports.firstBankAccount = firstBankAccount;
const isTransferAccountAvailable = (txn, isEntityGroupEnabledUser, accountsById) => {
    if (!transactions_1.transactionsUtils.isTransferTxn(txn) || !isEntityGroupEnabledUser) {
        return true;
    }
    const coaIds = (() => {
        var _a, _b;
        if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
            const splitItems = (_b = (_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
            return splitItems
                .map((split) => split === null || split === void 0 ? void 0 : split.coa)
                .filter((coa) => !!coa && coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT)
                .map((coa) => coa.id);
        }
        const coa = txn === null || txn === void 0 ? void 0 : txn.coa;
        if ((coa === null || coa === void 0 ? void 0 : coa.type) === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT && coa.id) {
            return [coa.id];
        }
        return [];
    })();
    if (coaIds.length === 0) {
        return false;
    }
    return coaIds.some((id) => Boolean(accountsById.get(id)));
};
exports.isTransferAccountAvailable = isTransferAccountAvailable;
const hasWriteAccessForAccountById = (_accountsById, isEntitySharedUser, currentDataset, accountGroups, accountId) => {
    var _a, _b;
    if (!isEntitySharedUser) {
        return true;
    }
    const writeGroupIds = (0, accountGroupUtils_1.deriveAccountGroupdIds)((_b = (_a = currentDataset.itemAccessControl) === null || _a === void 0 ? void 0 : _a.resources) === null || _b === void 0 ? void 0 : _b.ACCOUNT_GROUP, ['write']);
    const writeAccountIds = accountGroups === null || accountGroups === void 0 ? void 0 : accountGroups.filter((accountGroup) => writeGroupIds.includes(accountGroup.id)).flatMap((accountGroup) => accountGroup.accountIds);
    return writeAccountIds.includes(accountId);
};
exports.hasWriteAccessForAccountById = hasWriteAccessForAccountById;
